var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSunS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5022_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 0H5.5V2H6.5V0ZM0 5.5V6.5H2V5.5H0ZM12 5.5V6.5H10V5.5H12ZM6.5 12H5.5V10H6.5V12ZM4 3H8V4H4V3ZM3 4H4V8H3V4ZM4 9V8H8V9H4ZM9 8H8V4H9V8ZM10 1H11V2H10V1ZM10 2V3H9V2H10ZM11 11H10V10H11V11ZM10 10H9V9H10V10ZM2 1H1V2H2V3H3V2H2V1ZM1 11H2V10H3V9H2V10H1V11Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5022_13134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunS);
export default __webpack_public_path__ + "static/media/sun-s.f954dd61cace099c8bc335d97a503c38.svg";
export { ForwardRef as ReactComponent };